import { Chip } from "@/components/ui/chip";

export const BetaChip = () => (
  <Chip
    classNames={{
      content: "text-[10px] font-semibold uppercase tracking-wide px-1.5",
    }}
    color="warning"
    size="sm"
    variant="soft"
  >
    Beta
  </Chip>
);
